// Views/Pages/CustomerApplications/CustomerApplicationDetailContext.tsx

import { CustomerApplicationSummary } from "Hooks/Api/apiCustomerApplications";
import useApiCustomerApplications from "Hooks/Api/useApiCustomerApplications";
import { createContext, useContext, useState, ReactNode, useEffect } from "react";

export type CustomerApplicationDetailPageTabKeys = 'overview' | 'business-info' | 'adverse-alerts';

interface CustomerApplicationDetailContextType {
	model?: CustomerApplicationSummary;
	currentTab: CustomerApplicationDetailPageTabKeys;
	setCurrentTab: (tab: CustomerApplicationDetailPageTabKeys) => void;
}

const CustomerApplicationDetailContext = createContext<CustomerApplicationDetailContextType | undefined>(undefined);

export const useCustomerApplicationDetailContext = () => {
	const context = useContext(CustomerApplicationDetailContext);
	if (!context) {
		throw new Error("useCustomerApplicationDetailContext must be used within CustomerApplicationDetailProvider");
	}
	return context;
};

type CustomerApplicationDetailProviderProps = {
	// Customer Application Id
	id: string;
	children: ReactNode;
}

/**
 * Context and Provider for managing CustomerApplicationDetailPage.tsx
 */
export const CustomerApplicationDetailProvider = (props: CustomerApplicationDetailProviderProps) => {
	const {
		children,
		id
	} = props;

	const [currentTab, setCurrentTab] = useState<CustomerApplicationDetailPageTabKeys>("overview");
	const model = useApiCustomerApplications({id})

	const contextValue: CustomerApplicationDetailContextType = { 
		model: model.data,
		currentTab, 
		setCurrentTab
	}

	return (
		<CustomerApplicationDetailContext.Provider value={contextValue}>
			{children}
		</CustomerApplicationDetailContext.Provider>
	);
};